



























































































































































































































































































// tiptap stuff
import Document from '@tiptap/extension-document';
import Mention from '@tiptap/extension-mention';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import Link from '@tiptap/extension-link';
import CodeBlock from '@tiptap/extension-code-block';
import BulletList from '@tiptap/extension-bullet-list';
import ListItem from '@tiptap/extension-list-item';
import OrderedList from '@tiptap/extension-ordered-list';

// TODO: Enable lowlight syntax highlighting for code blocks in future implementation.
// TODO: Enable syntax highlighting for code blocks using CodeBlockLowlight and lowlight in future implementation.
// import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
// load all languages with "all" or common languages with "common"
// import { common, createLowlight } from 'lowlight'
// create a lowlight instance
// const lowlight = createLowlight(common)

// import TaskItem from '@tiptap/extension-task-item'
// import TaskList from '@tiptap/extension-task-list'

import { Editor, EditorContent, VueRenderer, posToDOMRect } from '@tiptap/vue-2';

import StarterKit from '@tiptap/starter-kit';

import Placeholder from '@tiptap/extension-placeholder';
import { HardBreak } from '@tiptap/extension-hard-break';

import CoPoll from '@/components/Organisms/co-poll/CoPoll.vue';
import { Cohashtag } from './Hashtag.js';
import HashtagSuggestion from '../../Organisms/Editor/hashtags/HashtagSuggestion';

import suggestion from './MentionSuggestion.js';

import { get, map, escape, unescape, isEqual } from 'lodash';
import xss from 'xss';
import * as linkify from 'linkifyjs';
import { normalizeAttachmentFile } from '@/utils/attachment';

import CoRoundButton from '../../Atoms/co-round-button/CoRoundButton.vue';
import CoEmojiPicker from '../co-emoji-picker/CoEmojiPicker.vue';
import CoFileInput from '../../Atoms/co-file-input/CoFileInput.vue';
import CoTippy from '../../Atoms/co-tippy/CoTippy.vue';
import CoThumbnail from '../co-thumbnail/CoThumbnail.vue';
import CoLoadingIndicator from '../../Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoInput from '../co-input/CoInput.vue';
import CoButton from '../../Atoms/co-button/CoButton.vue';
import { SUPPORTED_IMAGE_ACCEPT } from '@/constants/fileUpload';

export default {
    name: 'CoEditor',
    components: {
        CoRoundButton,
        Cohashtag,
        CoEmojiPicker,
        CoFileInput,
        CoTippy,
        CoThumbnail,
        CoLoadingIndicator,
        CoInput,
        CoButton,
        CoPoll,
    },
    props: {
        placeholder: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        hideLoadingIndicator: {
            type: Boolean,
            default: false,
        },
        multipleFiles: {
            type: Boolean,
            default: false,
        },
        border: {
            type: Boolean,
            default: true,
        },
        sendIcon: {
            type: String,
            default: 'send',
        },
        hideSendButton: {
            type: Boolean,
            default: false,
        },
        hideActions: {
            type: Boolean,
            default: false,
        },
        actionsPosition: {
            type: String,
            default: 'bottom-right',
            validator: (value) => ['top-left', 'top-right', 'bottom-left', 'bottom-right'].includes(value),
        },
        allowStyling: {
            type: Boolean,
            default: false,
        },
        variant: {
            type: String,
            validator: (value) => ['compact', 'full'].includes(value),
            default: 'compact',
        },
        focusOnStart: {
            type: Boolean,
            default: false,
        },
        prefilledContent: {
            type: Object,
            default: () => {},
        },
        mode: {
            type: String,
            default: 'normal',
            validator: (value) => ['normal', 'code'].includes(value),
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        disableMentions: {
            type: Boolean,
            default: false,
        },
        disableHashtags: {
            type: Boolean,
            default: false,
        },
        disableImages: {
            type: Boolean,
            default: false,
        },
        disableEmojis: {
            type: Boolean,
            default: false,
        },
        disablePoll: {
            type: Boolean,
            default: true,
        },
        disableAttachments: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            expanded: false,
            search: '',
            editor: null,

            query: null,
            filteredItems: [],

            isEditorEmpty: true,

            content: null, // HTML content of the editor
            text: null, // raw text of the editor content
            code: null, // code content of the editor
            files: [],
            attachments: [],
            mentions: [],
            hashtags: [],
            // generate the placeholder text on mount
            localPlaceholder: this.placeholder || this.$t('placeholders.posteditor'),
            addingLink: false,
            linkUrlToAdd: null,

            isPoll: false,
            pollDraft: null,

            imageAccept: SUPPORTED_IMAGE_ACCEPT,
        };
    },
    watch: {
        loading: {
            handler(newVal) {
                if (this.editor && this.editor.setOptions) {
                    this.editor.setOptions({
                        editable: !newVal,
                    });
                }
            },
        },
    },
    mounted() {
        const that = this;

        // map prefilled content to data
        this.mapPrefilledContent();

        // initialize the editor document according to the mode
        const CustomDocument = Document.extend({
            content: 'codeBlock',
        });

        this.editor = new Editor({
            element: this.$refs.editor,
            content: this.value,
            editable: !this.readonly,
            extensions: [
                this.mode === 'code' ? CustomDocument : null,
                StarterKit.configure(
                    this.mode === 'code'
                        ? {
                              document: false,
                          }
                        : null
                ),
                Placeholder.configure({
                    includeChildren: false,
                    placeholder: ({ node }) => this.localPlaceholder,
                }),
                Image,
                !this.disableMentions
                    ? Mention.configure({
                          HTMLAttributes: {
                              class: 'mention',
                          },
                          suggestion,
                      })
                    : null,
                !this.disableHashtags
                    ? Cohashtag.configure({
                          HTMLAttributes: {
                              class: 'hashtag',
                          },
                          suggestion: HashtagSuggestion,
                      })
                    : null,
                Link.configure({
                    openOnClick: true,
                    linkOnPaste: true,
                    HTMLAttributes: {
                        class: 'link',
                    },
                }),
                HardBreak,
                Document,
                Paragraph,
                Text,
                BulletList,
                ListItem,
                OrderedList,
                CodeBlock.configure({
                    HTMLAttributes: {
                        class: 'code-block',
                    },
                }),
            ],
            editorProps: {
                transformPastedHTML: (html = '') => {
                    // sanitize pasted HTML
                    const sanitizedHtml = this.allowStyling
                        ? xss(html, {
                              whiteList: {
                                  a: ['href', 'target', 'rel'],
                                  p: [],
                                  br: [],
                                  strong: [],
                                  em: [],
                                  b: [],
                                  i: [],
                                  ul: [],
                                  ol: [],
                                  li: [],
                                  h1: [],
                                  h2: [],
                                  h3: [],
                                  code: [],
                                  pre: [],
                              },
                              stripIgnoreTag: true,
                              stripIgnoreTagBody: ['script'], // the script tag is a special case, we need
                          })
                        : xss(html, {
                              whiteList: {}, // empty, means filter out all tags
                              stripIgnoreTag: true, // filter out all HTML not in the whilelist
                              stripIgnoreTagBody: ['script'], // the script tag is a special case, we need
                              // to filter out its content
                          });
                    // sanitize pasted HTML
                    return sanitizedHtml;
                },
            },
            onFocus({ editor, event }) {
                // The editor is focused.
                that.onFocus();
            },
            onBlur({ editor, event }) {
                // The editor isn’t focused anymore.
                that.onBlur();
            },
            onUpdate({ editor }) {
                // The editor content has changed.
                that.text = editor.getText();
                that.content = that.text.length > 0 ? editor.getHTML() : '';

                const parser = new DOMParser();
                const doc = parser.parseFromString(that.content, 'text/html');

                // extract mentions and hashtags
                that.mentions = Array.from(doc.querySelectorAll('.mention')).map((link) => ({
                    ...get(link, 'dataset', {}),
                }));
                that.hashtags = Array.from(
                    parser.parseFromString(that.content, 'text/html').querySelectorAll('.hashtag')
                ).map((link) => ({
                    ...get(link, 'dataset', {}),
                }));
                that.emitInput();
            },
            onSelectionUpdate({ editor, transaction }) {
                // only continue if allowStyling is true
                if (!that.allowStyling) return;
                // Check if there is a text selection
                const { view, state } = editor;
                const { from, to } = state.selection;
                const text = state.doc.textBetween(from, to, '');
                if (text.length === 0) return;
                // Show the bubble menu when text is selected
                const { selection } = state;
                const domRect = posToDOMRect(view, selection.from, selection.to);
                const formatMenu = that.$refs.customBubbleMenu;
                formatMenu.setProps({
                    getReferenceClientRect: () => domRect,
                });
                formatMenu.show();
            },
        });
        this.$nextTick(() => {
            // set the editor content on load if prefilled content is available
            if (this.text || this.content) {
                // Drafts store plain Text beside rich Html, so Html must win to keep restored formatting.
                const text = this.content || this.text || '';
                this.editor.chain().setContent(text, { emitUpdate: true, preserveWhitespace: 'full' }).run();
            } else if (this.code) {
                // render embed code in the editor
                this.editor
                    .chain()
                    .setContent(this.escape(this.code), {
                        emitUpdate: true,
                        preserveWhitespace: 'full',
                    })
                    .setCodeBlock()
                    .run();
            }

            if (this.focusOnStart) this.focus();

            this.$emit('ready', this);
        });
    },
    methods: {
        escape,
        unescape,
        /**
         * Clear the editor content
         * @param {boolean} emit - Emit the input event
         * @param {boolean} collapse - Collapse the editor
         * @return {void}
         */
        clear(collapse = false, emit = true) {
            this.files = [];
            this.pollDraft = null;
            this.isPoll = false;
            this.editor.chain().clearContent(true).blur().run();
            if (collapse) {
                this.collapse();
            }

            if (emit) {
                this.$emit('input', null);
            }
        },

        /**
         * Focus the editor
         * @return {void}
         */
        focus(expand = false) {
            this.editor.commands.focus('end');
            if (expand) {
                this.expand();
            }
        },

        /**
         * Collapse the editor
         * @return {void}
         */
        collapse() {
            this.expanded = false;
        },

        /**
         * Expand the editor
         * @return {void}
         */
        expand() {
            this.expanded = true;
        },
        /**
         * Function called when the editor is focused (onFocus)
         * Used to expand the editor if it's collapsed and to emit the focus event
         * @return {void}
         */
        onFocus() {
            this.$emit('onFocus');
            this.expanded = true;
        },

        /**
         * Function called when the editor is blurred (onBlur)
         * Used to to emit the blur event
         * @return {void}
         */
        onBlur() {
            // if((!this.content || this.content.length === 0) && (!this.files || this.files.length === 0)){
            //     this.expanded = false;
            // }
            this.$emit('onBlur');
        },
        onEscape(event) {
            this.$emit('onEscape', event);
        },
        uploadFile(file) {
            return new Promise((resolve, reject) => {
                resolve(file);
            });
        },
        previewFiles(event) {
            if (!event) return;
            const newFiles = map(event, (file) => ({
                file,
                url: URL.createObjectURL(file),
            }));
            if (this.files && this.files.length > 0) {
                this.files = [...this.files, ...newFiles];
            } else {
                this.files = newFiles;
            }
            this.emitInput();
        },
        attachedFile(event) {
            if (!event || event.length < 1) return;
            const file = event[0];
            const newattachment = normalizeAttachmentFile({
                blob: file,
                file_name: file.name,
                size: file.size,
                format: file.type,
                type: 'downloadable',
                visibility: 'community',
                url: URL.createObjectURL(file),
            });
            if (this.attachments && this.attachments.length > 0) {
                this.attachments = [...this.attachments, newattachment];
            } else {
                this.attachments = [newattachment];
            }
            this.emitInput();
        },
        removeAttachment(atmnt) {
            this.attachments = this.attachments.filter((attachment) => attachment.url !== atmnt.url);
            this.emitInput();
        },

        removeFile(index) {
            this.files.splice(index, 1);
            this.emitInput();
        },

        textAreaClass() {
            const result = [];

            if (this.taclass) result.push(this.taclass.split(' '));

            if (this.expanded) result.push('active');

            return result;
        },
        insertEmoji(emoji) {
            this.editor.chain().focus().insertContent(emoji).run();
        },

        mention(event) {
            this.editor.chain().focus().run();
            this.editor.chain().insertContent('@').run();
        },
        hashtag(event) {
            this.editor.chain().focus().insertContent(' #').run();
            this.editor.commands.focus();
        },
        send(event) {
            const content = {
                Text: this.text,
                Html: this.content,
                Files: this.files,
                Mentions: this.mentions,
                Hashtags: this.hashtags,
            };
            this.$emit('send', content);
        },
        insertMention(label, id) {
            this.editor
                .chain()
                .setContent({
                    type: 'paragraph',
                    content: [
                        {
                            type: 'mention',
                            attrs: {
                                id,
                                label,
                            },
                        },
                    ],
                })
                .insertContent(' ')
                .run();
        },
        emitInput() {
            const content = {
                Text: unescape(this.text),
                Html: this.content,
                Files: this.files,
                Mentions: this.mentions,
                Hashtags: this.hashtags,
                Attachments: this.attachments,
                // Keep both drafts in sync so switching modes does not drop text or poll state.
                Poll: this.pollDraft,
                IsPoll: this.isPoll,
            };
            this.$emit('input', content);
        },
        mapPrefilledContent() {
            this.text = get(this.prefilledContent, 'Text', null);
            this.content = get(this.prefilledContent, 'Html', null);
            this.code = get(this.prefilledContent, 'Code', null);
            this.files = get(this.prefilledContent, 'Files', []);
            this.attachments = get(this.prefilledContent, 'Attachments', []).map((attachment) =>
                normalizeAttachmentFile(attachment)
            );
            this.mentions = get(this.prefilledContent, 'Mentions', []);
            this.hashtags = get(this.prefilledContent, 'Hashtags', []);
            this.pollDraft = get(this.prefilledContent, 'Poll', null);
            this.isPoll = !!get(this.prefilledContent, 'IsPoll', false);

            // set the editor content if initialized
            if (!this.editor) return;

            if (this.text || this.content) {
                // Drafts store plain Text beside rich Html, so Html must win to keep restored formatting.
                const text = this.content || this.text || '';
                this.editor
                    .chain()
                    .setContent(text, { emitUpdate: true, preserveWhitespace: 'full' })
                    .setHardBreak()
                    .run();
            } else if (this.code) {
                // render embed code in the editor
                this.editor
                    .chain()
                    .setContent(this.escape(this.code), {
                        emitUpdate: true,
                        preserveWhitespace: 'full',
                    })
                    .setCodeBlock()
                    .run();
            }
            this.emitInput();
        },
        setLinkUrl() {
            if (!this.linkUrlToAdd || this.linkUrlToAdd.length < 1) {
                this.editor.chain().focus().unsetLink().run();
                this.linkUrlToAdd = null;
                return;
            }
            // Use linkify to find the URL in the input
            let linkedUrl = linkify.find(this.linkUrlToAdd);
            // If no valid URL is found, do not set the link
            if (!linkedUrl || linkedUrl.length < 1 || !linkedUrl[0].href) {
                return;
            }
            // make sure to use https as default protocol
            let linkedUrlString = get(linkedUrl, '[0].href', '').replace(/^(http)(s)?:\/\//, 'https://');
            this.editor.chain().focus().setLink({ href: linkedUrlString, target: '_blank' }).run();
            this.linkUrlToAdd = null;
            this.addingLink = false;
        },
        pollUpdated(poll) {
            // Guard against redundant write-backs from poll draft sync.
            if (!isEqual(this.pollDraft, poll)) {
                this.pollDraft = poll;
            }
            const content = {
                Text: this.text,
                Html: this.content,
                Files: this.files,
                Mentions: this.mentions,
                Hashtags: this.hashtags,
                Poll: poll,
                IsPoll: true,
            };
            this.$emit('input', content);
        },
        openPollBuilder() {
            this.isPoll = true;
        },
        exitPollBuilder() {
            this.isPoll = false;
            this.emitInput();
            this.$nextTick(() => {
                this.focus();
            });
        },
    },
    beforeDestroy() {
        this.editor.destroy();
    },
};
